import React, {Component, useCallback, useEffect, useState} from "react";
import styled, {css} from "styled-components";

import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";


function KitPanel({kitList, setKitList, itemList, setItemList, saveKit}) {
    const [kitLists, setKitLists] = useState([])
    const [selectedKit, setSelectedKit] = useState(null)
    const [selectedComponent, setSelectedComponent] = useState(null)
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedQuantity, setSelectedQuantity] = useState(1)
    useEffect(() => {
        setKitLists(kitList)
    }, [kitList])
    const handleAddKit = () => {
        if (selectedItem) {
            let updatedKit = [...kitLists]


            updatedKit.unshift({id: selectedItem.id, name: selectedItem.name, component: []})
            setKitLists(updatedKit)
        }
    }
    const handleDeleteKit = () => {
        if (selectedKit) {
            let updatedKit = [...kitLists]
            updatedKit = updatedKit.filter(it => it.id !== selectedKit.id)
            setSelectedKit(null)
            setKitLists(updatedKit)

        }
    }
    const handleAddComponent = () => {
        if (selectedItem && selectedQuantity > 0 && selectedKit) {

            let updatedKit = [...kitLists]
            let updateKitComponent: [] = updatedKit.find(it => it.name.trim() === selectedKit.name.trim()).components || []
            updateKitComponent.unshift({id: selectedItem.id, name: selectedItem.name, quantity: selectedQuantity})
            updatedKit.find(it => it.name.trim() === selectedKit.name.trim()).components = updateKitComponent
            setKitLists(updatedKit)
        }
    }
    const handleDeleteComponent = () => {
        if (!selectedKit.id === 0 || !selectedComponent || selectedComponent.id === 0) return;


        setKitLists(prev =>
            prev.map(kit =>
                kit.id !== selectedKit.id
                    ? kit
                    : {
                        ...kit,
                        // use "components" or "component" consistently across the app
                        components: (kit.components ?? []).filter(c => c.id !== selectedComponent.id),
                    }
            )
        );


    };
    return (
        <>
            <div
                className="container flex flex-column  justify-content-center align-items-center w-screen m-2 h-full ">
                <div className="container flex flex-row justify-content-around align-content-center w-fit h-full">
                    <div className="container  flex flex-row justify-content-start align-items-end w-4  mb-2">
                        <Button className="pi pi-arrow-circle-down h-3rem"
                                onClick={
                                    handleAddKit
                                }
                        ></Button>
                        <Button className="pi pi-arrow-circle-up  h-3rem"
                                style={{
                                    transform: "rotate(undefined)"
                                }} onClick={
                            handleDeleteKit
                        }
                        ></Button>

                    </div>
                    <div
                        className="  card flex flex-row justify-content-start  mb-2">
                        <DataTable value={itemList.map(it => {
                            return {
                                id: it.id,
                                name: it.name
                            }
                        })}
                                   dataKey="id"
                                   selectionMode="single" selection={selectedItem} size={"small"}
                                   scrollable={true}
                                   scrollHeight="220px" className="pr-2 "
                                   onSelectionChange={(e) => (
                                       setSelectedItem({
                                           name: e.value.name,
                                           id: e.value.id,
                                       })
                                   )}>
                            <Column field="name" header="Item"
                                    headerStyle={{backgroundColor: '#fff0f0'}}></Column>
                        </DataTable>
                    </div>
                    <div
                        className=" flex flex-column justify-content-around w-2 h-full">
                        <Button className="pi pi-arrow-circle-up w-4rem h-3rem"
                                style={{
                                    transform: "rotate(undefined)"
                                }} onClick={handleDeleteComponent}
                        >
                        </Button>
                        <InputNumber value={selectedQuantity} onValueChange={(e) => setSelectedQuantity(e.value)}
                                     showButtons
                                     buttonLayout="vertical"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                     className="w-4rem "
                        />
                        <Button className="pi pi-arrow-circle-down"
                                style={{
                                    height: 43,
                                    width: 56,

                                }} onClick={handleAddComponent}
                        ></Button>
                    </div>
                </div>

                <div
                    className="container flex sm:flex-column md:flex-row justify-content-center align-items-start w-full h-full">
                    <div
                        className="container card flex flex-fill justify-content-center  align-items-start w-8 md:w-5 h-full bg-gray-100 border-round-sm border-1 shadow p-2 mr-2">
                        <DataTable value={kitLists.map(it => {
                            return {
                                id: it.id,
                                name: it.name
                            }
                        })}
                                   selectionMode="single" selection={selectedKit} size="small" scrollable={true}
                                   scrollHeight={"230px"} className="p-2 w-full "
                                   onSelectionChange={(e) => {
                                       if (e.value) {
                                           setSelectedKit({
                                               name: e.value.name,
                                               id: e.value.id,
                                           })
                                       }
                                   }}>
                            <Column field="name" header="Kit"
                                    headerStyle={{width: '50px', backgroundColor: '#fff0f0'}}></Column>
                        </DataTable>

                    </div>
                    <div
                        className="container card flex flex-column  justify-content-center  align-content-center w-8 md:w-6 h-20 bg-gray-100 border-round-sm border-1 flex-fit shadow">
                        <DataTable
                            value={
                                selectedKit
                                    ? (kitLists.find(k => k.id === selectedKit.id)?.components ?? []).map(c => ({
                                        id: c.id,
                                        name: c.name,
                                        quantity: c.quantity,
                                    }))
                                    : []
                            }
                            dataKey="id" selection={selectedComponent} selectionMode="single" scrollable={true}
                            scrollHeight="230px" size={"small"} className="pt-2 w-full"
                            onSelectionChange={(e) => {
                                setSelectedComponent(e.value)
                            }}
                        >
                            <Column field="name" header="Component"
                                    headerStyle={{width: '50px', backgroundColor: '#fff0f0'}}></Column>
                            <Column field="quantity" header="Quantity"
                                    headerStyle={{width: '50px', backgroundColor: '#fff0f0'}}></Column>
                        </DataTable>
                    </div>
                </div>
                <Button label="Save Changes" onClick={() => {
                    saveKit(kitLists)

                }} className="w-fit h-fit m-2"

                ></Button>

            </div>
        </>
    )
}

export default KitPanel;
